import AdsManager, { InitManagerParams } from './AdsManager';
import { configureForDevelopment } from './placement/local';
/////////////////
////////////////////////////////////////////////////////////////////////////////
/////////
import adSettings from './config/adsettings';
import { enableDMVerticals, getAdScheduleId, getAdTag } from './config/adschedule';
import ppid from './config/ppid';
import adConfig from './config/adslots';
import getConsent from './consent/consent';
import { checkTopAdsLoaded, clearSlots } from './googletag/googletag';
import amaLog, { amaAlert, amaWarn, isDebugTs } from './helpers/log';
import { timeFor } from './helpers/time';
import { collector } from './adstats/collector';
import waitFor from './helpers/waitfor';
import {
  initAdResources,
  tcfApiLoaded,
  handleDemandManager,
  isAnyPlacementsLoaded,
  handleGpt,
  loadAdnScript,
} from './resource/resource';
import { isVideoPage } from './config/domain';
import { isMainAndCategoryPage, stringIfAny } from './helpers/utils';
import { getModules } from './modules/index';
import { getHostName } from './config/domain';
import { parseAdsConfig } from './config/platform';
import {
  setAdLoadedForDiv,
  AD_PLACEMENT_ATTRIBUTE,
  AD_LOADED_ATTRIBUTE,
  setAdLoadedForElement,
  resolveTarget,
} from './placement/placement';
import { isArticle } from './config/device';
/////////////////
///////////////////////////////////////////////
/////////
amaLog(`Start running adsBundle ${timeFor('runBundle')}`);

let processedUniqueIds: string[] = [];
let proccessedPlacementIds = new Set<string>();
let serverLoadedConfig: IAdsConfig | undefined;
let amaPageNo = [...processedUniqueIds].length;
let accConfig: IAdsConfig | undefined;
let pageHasBeenInitialized = false;
let pageInitStarted = false;
let hasConsent: boolean;
let usePrebid: boolean;
let firstLoad = true;
let pageReset = true;
let responsivesCounter = 0;

let placementNameCounter: { [key: string]: number } = {};

// get attribute ads-conf from current script
const adsPlatformConfJson =
  (document.getElementById('ads-manager') || document.querySelector('script[data-ads-conf]'))?.getAttribute(
    'data-ads-conf',
  ) || undefined;

const parsedConfig = parseAdsConfig(adsPlatformConfJson);
const { loadedByAdsLib } = parsedConfig;

const placementLog = (uniqueId: string) => {
  if (isDebugTs()) {
    const processedUniqueIdsClone = structuredClone(processedUniqueIds);
    const proccessedPlacementIdsClone = structuredClone(proccessedPlacementIds);

    amaLog('observer - placementLog: ', { uniqueId, processedUniqueIdsClone, proccessedPlacementIdsClone });

    if (uniqueId !== '') {
      const isUniqueIdHandled = processedUniqueIdsClone.includes(uniqueId);
      !isUniqueIdHandled && amaAlert(`placementLog - ${uniqueId} is NOT handled`);

      const foundPlacements = document.querySelectorAll(`div[id$='${uniqueId}'][${AD_PLACEMENT_ATTRIBUTE}]`);

      Object.entries(foundPlacements).map((placement) => {
        const placementId = placement[1].id;
        const isPlacementHandled = proccessedPlacementIdsClone.has(placementId);

        !isPlacementHandled && amaAlert(`placementLog - ${placementId} is NOT handled`);
      });
    }
  }
};

const isPlacementsLoaded = (uniqueId: string) =>
  !!document.querySelector<HTMLElement>(`div[${AD_PLACEMENT_ATTRIBUTE}][id$="-${uniqueId}"]`);

const isAdLoaded = (div: HTMLElement) => !!div && div.hasAttribute(AD_LOADED_ATTRIBUTE);

const getNoOfArticlesWithAds = () => {
  const foundPlacements = document.querySelectorAll(`div[${AD_PLACEMENT_ATTRIBUTE}$='intext_ad_1']`);
  return foundPlacements?.length ?? 0;
};

const initPage = async (dfpSection: string) => {
  // ### 1 Handle multiple call to initPage() ###
  if (pageHasBeenInitialized) return;

  if (pageInitStarted) {
    // Wait for page to be initialized
    await waitFor(() => pageHasBeenInitialized, {
      timeout: 20000,
      errorMessage: `Timeout: Ad waited for config and consent`,
    });
    return;
  }
  pageInitStarted = true;

  amaLog('initPage()');

  // ### 2 Load ad modules, adSettings and accAdConfig ###
  const { useStats, useLimitedAds, usePoliticalAds } = getModules();

  adSettings.refresh();

  amaLog('Get page data ', getHostName(), adSettings.device, { ...adSettings });

  // ### 3 Load dependencies: tcfapi, consent, gpt ###

  await tcfApiLoaded();

  hasConsent = await getConsent();

  await handleGpt(loadedByAdsLib);

  // ### 4 Load modules: adwatch, limitedAds, prebid ###

  useStats && collector.start({ useStatsCollector: accConfig?.statscollector, hasConsent });

  if (!hasConsent && useLimitedAds) {
    amaLog(`useLimitedAds`);
    window.ama.adsUseDemandManager = 'false';
  }
  usePrebid = hasConsent && window.ama?.adsUseDemandManager === 'true';

  if (usePrebid) {
    amaLog(`usePrebid `);
    await handleDemandManager();
    enableDMVerticals(accConfig?.verticals);
  }
  if (usePoliticalAds) {
    amaLog(`usePoliticalAds `);
    await loadAdnScript();
  }

  const adsInitParams: InitManagerParams = {
    dfpSection: dfpSection,
    hasConsent,
    adsConfig: accConfig,
    _ppId: ppid.get(),
    videoOnly: isVideoPage(),
    placementLog: placementLog,
    usePrebid: usePrebid,
    pageReset: pageReset,
  };
  pageReset = false;

  AdsManager.initConfig(adsInitParams);

///////////////////
///////////////////////////////////////
/////////////////////////////
///////////

  pageHasBeenInitialized = true;
};

const initializeAd = async (divId: string, options: InitOptions = {}): Promise<void> => {
  amaLog('initializeAd()', divId, options, timeFor('initializeAd'));

  try {
    let { dfpSection, isSecondArticle, pageNo } = options;

    const { useSecondArticle } = getModules();

    await initPage(dfpSection);

    useSecondArticle &&
      amaLog(
        `secondarticle for ${divId} isArticle()${isArticle()} amaPageNo${amaPageNo} noOfArticlesWithAds :${getNoOfArticlesWithAds()}`,
      );

    if (useSecondArticle && isArticle() && pageNo === 2 && getNoOfArticlesWithAds() > 1) {
      amaLog(`observer isSecondArticle with ads: true`);
      isSecondArticle = true;
    }

    const adsInitParams: InitManagerParams = {
      dfpSection: dfpSection,
      hasConsent,
      isSecondArticle,
      pageNo,
      divId,
      pageReset: pageReset,
    };
    pageReset = false;

    AdsManager.initAd(adsInitParams);

    pageNo === 1 && divId.includes('top_ad') && checkTopAdsLoaded(divId);
  } catch (error) {
    console.error('Error initializing Ad ', error);
  }
};

/**
 * Initializes the loading of ads on a page.
 * @param uniqueId The unique ID appended to placements div-ids.
 * @param options Custom settings, e.g., { dfpSection = "..." }.
 * @returns A Promise that resolves once the initialization is complete.
 */
const initializeAds = async (
  adsUniqueId: string | number = window.ama?.adsUniqueId || window.adsUniqueId,
  options: InitOptions = {},
): Promise<void> => {
  amaLog('initializeAds()', adsUniqueId, options, timeFor('initializeAds'));

  const {
    useStats,
    useLimitedAds,
/////////////////////
//////////////////
/////////////
/////////////////////
////////////////////
/////////////
    usePlacementCheck,
    useSecondArticle,
  } = getModules();

  try {
    amaLog('adsUniqueId, stringIfAny(adsUniqueId)', adsUniqueId, stringIfAny(adsUniqueId));
    let uniqueId = stringIfAny(adsUniqueId);
    let { dfpSection, isSecondArticle } = options;
    const videoOnly = isVideoPage();

    const adsInitParams: InitManagerParams = { dfpSection: dfpSection };

    adsInitParams['pageNo'] = getPageNo();

    adSettings.refresh();

    amaLog('Get config for ', uniqueId, getHostName(), adSettings.device, adsInitParams['pageNo'], { ...adSettings });

    timeFor('confLoad');
    let config: any = await adConfig.getModifiedConfig(serverLoadedConfig);

    if (usePlacementCheck && !videoOnly) {
      amaLog('usePlacementCheck', usePlacementCheck);

      if (!isPlacementsLoaded(uniqueId)) {
        amaLog(`Ads:: Wait for Placement Wrappers to be loaded for ${uniqueId} ...`);
        await waitFor(() => isPlacementsLoaded(uniqueId), {
          timeout: 20000,
          errorMessage: `Timeout: Placementwrappers are missing for ${uniqueId}`,
        });
      }
      amaLog('Ads:: Placement Wrappers Loaded for ', uniqueId);
    }

    await tcfApiLoaded();

    const hasConsent = await getConsent();

    await handleGpt(loadedByAdsLib);

    amaLog(
      `After handleGpt ${timeFor('afterGpt')}`,
      window.googletag?.pubadsReady,
      window.googletag?.getConfig(['targeting', 'adsenseAttributes', 'disableInitialLoad']),
    );

    if (!hasConsent && useLimitedAds) {
      amaLog(`useLimitedAds`);
      window.ama.adsUseDemandManager = 'false';
    }
    const usePrebid = hasConsent && window.ama?.adsUseDemandManager === 'true';

    if (usePrebid) {
      amaLog(`usePrebid `);
      await handleDemandManager();
    }

    useStats && collector.start({ useStatsCollector: config?.statscollector });
/////////////////////
////////////////////////////////////////////////
/////////////

    if (useSecondArticle && isArticle() && adsInitParams['pageNo'] === 2 && getNoOfArticlesWithAds() > 1) {
      amaLog(`observer waitFor isSecondArticle `);
      await waitFor(() => typeof window.ama?.isSecondArticle !== 'undefined', {
        timeout: 2000,
        errorMessage: `Timeout: window.ama.isSecondArticle is missing `,
      });
      isSecondArticle = !!window.ama?.isSecondArticle;
      amaLog(
        `observer wait done for isSecondArticle. Calling init(): adsUniqueId ${adsUniqueId} isSecondArticle: ${isSecondArticle} `,
      );
    }
    adsInitParams['adsConfig'] = config;
    adsInitParams['uniqueId'] = uniqueId;
    adsInitParams['hasConsent'] = hasConsent;
    adsInitParams['isSecondArticle'] = isSecondArticle;

    if (firstLoad) {
      adsInitParams._ppId = ppid.get();
      adsInitParams.videoOnly = videoOnly;
      adsInitParams.placementLog = placementLog;
      adsInitParams.usePrebid = usePrebid;
      firstLoad = false;
    }

    adsInitParams['pageReset'] = pageReset;
    pageReset = false;

    AdsManager.init(adsInitParams);
    adsInitParams['pageNo'] === 1 && checkTopAdsLoaded(`top_ad-${uniqueId}`);
  } catch (error) {
    console.error('Error initializing ads:', error);
  }
};

const getPageNo = () => [...processedUniqueIds].length;

const notLoadedAdPlacementSelector = `div[${AD_PLACEMENT_ATTRIBUTE}]:not([${AD_LOADED_ATTRIBUTE}])`;

const isResponsiveAd = (placement: string) => placement.startsWith('responsive_');

const handleFoundPlacement = (div: HTMLElement) => {
  // ToDo: set div-id for placements if they are missing
  amaLog('handleFoundPlacement ', div.id);

  if (isAdLoaded(div)) {
    amaLog(` handleFoundPlacements ${div.id} already loaded. Skipping ...`);
    return;
  }
  // Update Ad loaded attribute
  setAdLoadedForElement(div);

  // Count suffix for placement
  const attributePlacement = div.getAttribute(AD_PLACEMENT_ATTRIBUTE);

  // Set/Update div placement attribute
  const placement = resolveTarget(attributePlacement, accConfig, div) || attributePlacement;
  if (!placement) {
    amaWarn(`handleFoundPlacement - placement ${attributePlacement} not found in config for `, div);
    return;
  }

  let newPlacement = placement;

  // On main/category modify responsive placements to be 1-8, x,x,x ...
  if (isMainAndCategoryPage() && isResponsiveAd(newPlacement)) {
    responsivesCounter += 1;
    const placementNo = responsivesCounter > 8 ? 'x' : `${responsivesCounter}`;
    newPlacement = `responsive_${placementNo}`;
    newPlacement !== placement && div.setAttribute(AD_PLACEMENT_ATTRIBUTE, newPlacement);
  }

  placementNameCounter[newPlacement] = placementNameCounter[newPlacement] ? placementNameCounter[newPlacement] + 1 : 1;

  let pageNo = 1;
  if (!newPlacement.startsWith('top_ad')) {
    pageNo = Math.max(placementNameCounter['intext_ad_1'] ?? 1, placementNameCounter['responsive_1'] ?? 1);
  }

  // Set/Update div id and placement in sequence to be unique
  const placementId = `${newPlacement}-${placementNameCounter[newPlacement]}`;
  div.id = placementId;

  amaLog(
    `handleFoundPlacement placement:${newPlacement} count:${placementNameCounter[newPlacement]} div.id:${div.id} pageNo:${pageNo}`,
  );

  initializeAd(placementId, { pageNo: pageNo });
};

const placementObserver = new MutationObserver((mutationsList: MutationRecord[]) => {
  for (const mutation of mutationsList) {
    if (mutation.type !== 'childList') continue;

    for (const node of mutation.addedNodes) {
      if (node.nodeType !== 1) continue; // Element nodes only

      const element = node as HTMLElement;

      if (element.matches(notLoadedAdPlacementSelector)) {
        handleFoundPlacement(element);
      }

      const nested = element.querySelectorAll(notLoadedAdPlacementSelector);
      for (const child of nested) {
        handleFoundPlacement(child as HTMLElement);
      }
    }
  }
});

const handlePlacementsInContent = (content?: HTMLElement) => {
  // Scan for placements that are not marked handled (ad-loaded)
  const placementsToLoad = (content || document).querySelectorAll<HTMLElement>(notLoadedAdPlacementSelector);

  handleFoundPlacements(Array.from(placementsToLoad));
};

const handleFoundPlacements = (placementsToLoad: HTMLElement[]) => {
  if (placementsToLoad && placementsToLoad.length > 0) {
    amaLog(
      `PlacementManager - Found ${placementsToLoad.length} (${timeFor(
        'handlePlacementsInContent',
      )}) placements to handle`,
      placementsToLoad,
    );

    for (let i = 0; i < placementsToLoad.length; i++) {
      handleFoundPlacement(placementsToLoad[i]);
    }
  }
};

const resetInitLoad = () => {
  amaLog('resetInitLoad');
  clearSlots();
  processedUniqueIds = [];
  proccessedPlacementIds = new Set<string>();
  placementNameCounter = {};
  responsivesCounter = 0;
  pageReset = true;
  const { useStats, useContentUpdatedEvent } = getModules();
  if (!useContentUpdatedEvent) {
    placementObserver.disconnect();
    placementObserver.observe(document.body, { childList: true, subtree: true });
  }
  useStats && collector.start({ useStatsCollector: accConfig?.statscollector, reset: true, hasConsent });
};

const initHandleInjectedContent = async () => {
  amaLog(`Init handling injected content ...`, timeFor('initInjectedContentHandling'));

  window.ama.handleContent = (content) => {
    amaLog(`window.ama.handleContent ...`, timeFor('handleContent'), content);
    handlePlacementsInContent(content);
  };
};

const initPlacementHandling = async () => {
  amaLog(`initPlacementHandling ...`, timeFor('initPlacementHandling'));

  const { usePlacementCheck } = getModules();

  if (usePlacementCheck) {
    if (!isAnyPlacementsLoaded() && !isVideoPage()) {
      amaLog(`initPlacementHandling: - Wait for Placement Wrapper to be loaded ...`);
      await waitFor(isAnyPlacementsLoaded, {
        timeout: 5000,
        errorMessage: `Timeout: Placementwrappers are missing `,
      });
    }
    amaLog('initPlacementHandling: Placement Wrapper is loaded', timeFor('initPlacementHandling'));
  }
/////////////////
//////////////////////////////////
///////////

  handlePlacementsInContent();
  if (isVideoPage()) {
    amaLog(`initPlacementHandling isVideoPage ... `);
    initializeAds();
  }
};

amaLog('adsPlatformConfJson', parsedConfig);

initAdResources(parsedConfig)
  .then((config) => {
    amaLog('AdResources loaded');

    accConfig = config;

    if (!accConfig || !(accConfig?.ads && accConfig.ads.length > 0)) {
      amaAlert('No valid ad config found');
      return;
    }
    const { useSecondArticle, useContentUpdatedEvent } = getModules();
    if (window.ama) {
      window.ama.init = async (uniqueId?: string | number, options?: InitOptions): Promise<void> => {
        amaLog('window.ama.init called initializeAds ...', options);

        if (options?.dfpSection === 'general') {
          // Remove posibility to override to a general section
          // ToDo: Remove when response from ads-microservice no longer has dfpSection
          options = { ...options, dfpSection: undefined };
        }
        amaLog('options', options);

        if (useSecondArticle && isArticle()) {
          const { isSecondArticle } = options || {};

          window.ama.isSecondArticle = !!isSecondArticle;
          amaLog('observer - isSecondArticle', window.ama.isSecondArticle);
        }
      };
      amaLog('window.ama.init available');

      window.ama.clearSlots = (): void => {
        resetInitLoad();
      };
      amaLog('window.ama.clearSlots available');
    }
    adSettings.init();

    if (useContentUpdatedEvent) {
      initHandleInjectedContent();
      handlePlacementsInContent();
    } else {
      amaLog('Init Observer for handling placements');

      placementObserver.observe(document.body as HTMLElement, { childList: true, subtree: true });
      initPlacementHandling();
    }

    if (window.ama) {
      window.amav = {
        getAdScheduleId,
/////////////////////////
/////////////////////////////////////////////////////////
/////////////////
        getVideoPpId: ppid.get,
        getAdTag: (...videoConfig) => getAdTag(accConfig, ...videoConfig),
      };
      amaLog('window.ama.video available');
    }
  })
  .catch((error) => {
    console.error('AdResources fail to load', error);
  });
